import dayjs from "dayjs"

import { HealthDocument } from "../../../contexts/health-context"
import { DefaultMantineColor } from "@mantine/core"
import { useCallback } from "react"

export type DeviceStatusLabels = "online" | "offline" | "pending" | "uncertain" | "starting" | "shutting down" | "disconnected"

export const colorPerStatus: Record<DeviceStatusLabels, DefaultMantineColor> = {
    online: "green",
    offline: "dark",
    pending: "blue",
    uncertain: "gray",
    starting: "green",
    "shutting down": "dark",
    disconnected: "red",
}

export default () =>
    useCallback((health: HealthDocument | null | undefined): DeviceStatusLabels => {
        if (!health?.status) return "uncertain"
        else if (health.status === "on") {
            if (health.timestamp.isBefore(dayjs().subtract(3, "hour"))) return "pending"
            else if (health.nextShutdown?.isBefore(dayjs())) {
                if (health.nextShutdown.isAfter(dayjs().subtract(15, "minutes"))) return "shutting down"
                else return "pending"
            } else return "online"
        } else if (health.status === "off") {
            if (health.nextStartup?.isBefore(dayjs())) {
                if (health.nextStartup.isAfter(dayjs().subtract(15, "minutes"))) return "starting"
                else return "pending"
            } else return "offline"
        } else return health.status
    }, [])
